<template>
	<div class="modal fade" tabindex="-1" id="modalDefault">
		<div class="modal-dialog" role="document">
			<div class="modal-content">
				<a href="#" class="close" data-dismiss="modal" aria-label="Close">
					<em class="icon ni ni-cross"></em>
				</a>
				<div class="modal-header">
					<h5 class="modal-title">{{ $t('modal_inspection_title') }}</h5>
				</div>
				<div class="modal-body">
					<form
						action="#"
						class="form-validate is-alter"
						novalidate="novalidate"
					>
						<ul class="nav nav-tabs nav-tabs-s2">
							<li class="nav-item">
								<a class="nav-link " data-toggle="tab" href="#tabItem1"
									>{{ $t('modal_inspection_general') }}</a
								>
							</li>
							<li class="nav-item">
								<a class="nav-link active" data-toggle="tab" href="#tabItemP2"
									>{{ $t('modal_inspection_chapters') }}</a
								>
							</li>
							<li class="nav-item">
								<a class="nav-link" data-toggle="tab" href="#tabItemP3"
									>{{ $t('modal_inspection_style') }}</a
								>
							</li>
							<li class="nav-item">
								<a class="nav-link" data-toggle="tab" href="#tabItemP4"
									>{{ $t('modal_inspection_states') }}</a
								>
							</li>
						</ul>
						<div class="tab-content">
							<div class="tab-pane " id="tabItem1" style="padding-top: 20px">
								<div class="form-group">
									<div class="row gy-4">
										<div class="col-sm-6">
											<div style="margin-bottom: 20px">
												<div class="form-group">
													<label class="form-label" for="default-01">
														{{ $t('modal_inspection_report_style') }}
													</label>
													<select
														v-model="reportEntry.reportLayout"
														style="max-width: 60%"
														class="form-control"
													>
														<option value="1">{{ $t('modal_inspection_standard') }}</option>
														<option value="2">{{ $t('modal_inspection_layout2') }}</option>
													</select>
												</div>
											</div>
											<div class="form-group">
												<label class="form-label" for="default-01"
													>{{ $t('modal_inspection_report_picture') }}</label
												>
												<div class="form-control-wrap">
													<div class="custom-control custom-checkbox">
														<input
															type="checkbox"
															class="custom-control-input"
															id="customCheck1"
															v-model="reportEntry.reportimage"
														/>
														<label
															class="custom-control-label"
															for="customCheck1"
															>{{ $t('modal_inspection_show_report_image') }}</label
														>
													</div>
													<div
														v-if="reportEntry.reportimage"
														style="margin-top: 10px"
													>
														<select
															class="form-control"
															style="max-width: 60%"
															v-model="reportEntry.reportimagefile"
														>
															<option
																:value="item.file"
																v-for="item in imglib_list"
																:key="item.uid"
															>
																{{ item.name }}
															</option>
														</select>
														<div
															class="form-group"
															v-if="reportEntry.reportimage"
															style="margin-top: 10px"
														>
															<label class="form-label" for="default-01"
																>{{ $t('modal_inspection_report_image_width') }}</label
															>
															<div class="form-control-wrap">
																<input
																	v-model="reportEntry.reportimagewidth"
																	type="text"
																	style="max-width: 60%"
																	class="form-control"
																	id="default-01"
																	placeholder="Image width"
																/>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div class="col-sm-6">
											<div class="form-group">
												<label class="form-label"
													>{{ $t('modal_inspection_cpc') }}</label
												>
												<div class="form-control-wrap">
													<div class="custom-control custom-checkbox">
														<input
															type="checkbox"
															class="custom-control-input"
															id="customCheckCpc12"
															v-model="reportEntry.reportContinuousNumbering"
														/>
														<label
															class="custom-control-label"
															for="customCheckCpc12"
															>{{ $t('modal_inspection_complete_numbering') }}</label
														>
													</div>
												</div>
											</div>
											<div class="form-group">
												<div class="form-control-wrap">
													<div class="custom-control custom-checkbox">
														<input
															type="checkbox"
															class="custom-control-input"
															id="customCheckCpc10"
															v-model="reportEntry.reportTargetState"
														/>
														<label
															class="custom-control-label"
															for="customCheckCpc10"
															>{{ $t('modal_inspection_hide_target') }}</label
														>
													</div>
												</div>
											</div>
											<div class="form-group">
												<div class="form-control-wrap">
													<div class="custom-control custom-checkbox">
														<input
															type="checkbox"
															class="custom-control-input"
															id="customCheckCpc11"
															v-model="reportEntry.reportLocationData"
														/>
														<label
															class="custom-control-label"
															for="customCheckCpc11"
															>{{ $t('modal_inspection_show_location') }}</label
														>
													</div>
												</div>
											</div>
											<!--
                      <div class="form-group" style="margin-top: 10px">
                        <label class="form-label" for="default-decimal-places">Decimal places</label>
                        <div class="form-control-wrap">
                          <input v-model="reportEntry.reportiDecimalPlaces" type="text" style="max-width: 10%"
                            class="form-control" id="default-decimal-places" />
                        </div>
                      </div>
                      -->
										</div>
									</div>
								</div>
								<hr />

								<div class="form-group">
									<div class="row gy-4">
										<div class="col-sm-6">
											<div class="form-group">
												<div class="form-control-wrap">
													<div class="custom-control custom-checkbox">
														<input
															type="checkbox"
															class="custom-control-input"
															id="customCheck5"
															v-model="reportEntry.twoImagesInRow"
														/>
														<label
															class="custom-control-label"
															for="customCheck5"
															>{{ $t('modal_inspection_2_images') }}</label
														>
													</div>
												</div>
											</div>
											<div class="form-group">
												<div class="form-control-wrap">
													<div class="custom-control custom-checkbox">
														<input
															type="checkbox"
															class="custom-control-input"
															id="customCheck5c"
															v-model="reportEntry.oneImageInRow"
														/>
														<label
															class="custom-control-label"
															for="customCheck5c"
															>{{ $t('modal_inspection_1_image') }}</label
														>
													</div>
												</div>
											</div>

											<div
												class="form-group"
												v-if="reportEntry.oneImageInRow"
												style="margin-top: 10px"
											>
												<div class="form-control-wrap">
													<input
														v-model="reportEntry.oneImageMaxWidth"
														type="text"
														style="max-width: 60%"
														class="form-control"
														id="default-01"
														placeholder="e.g. 500"
													/>
													<small class="form-text text-muted">
														{{ $t('modal_inspection_max_image_width') }}
													</small>
												</div>
											</div>
											<div class="form-group">
												<div class="form-control-wrap">
													<div class="custom-control custom-checkbox">
														<input
															type="checkbox"
															class="custom-control-input"
															id="customCheck5b"
															v-model="reportEntry.imagesBelowChapter"
														/>
														<label
															class="custom-control-label"
															for="customCheck5b"
															>{{ $t('modal_inspection_images_below') }}</label
														>
													</div>
												</div>
											</div>
											<div class="form-group">
												<div class="form-control-wrap">
													<div class="custom-control custom-checkbox">
														<input
															type="checkbox"
															class="custom-control-input"
															id="customCheck19"
															v-model="reportEntry.reportColouredState"
														/>
														<label
															class="custom-control-label"
															for="customCheck19"
															>{{ $t('modal_inspection_coloured_state') }}</label
														>
													</div>
												</div>
											</div>

											<label class="form-label" for="default-01"
												>{{ $t('modal_inspection_offshore') }}</label
											>
											<div class="form-group">
												<div class="form-control-wrap">
													<div class="custom-control custom-checkbox">
														<input
															type="checkbox"
															class="custom-control-input"
															id="customCheck30"
															v-model="reportEntry.reportBarState"
														/>
														<label
															class="custom-control-label"
															for="customCheck30"
															>{{ $t('modal_inspection_state_bars') }}</label
														>
													</div>
												</div>
											</div>
											<div class="form-group">
												<div class="form-control-wrap">
													<div class="custom-control custom-checkbox">
														<input
															type="checkbox"
															class="custom-control-input"
															id="customCheck31"
															v-model="reportEntry.reportConditionGrade"
														/>
														<label
															class="custom-control-label"
															for="customCheck31"
															>{{ $t('modal_inspection_condition_grade') }}</label
														>
													</div>
												</div>
											</div>
										</div>
										<div class="col-sm-6">
											<div class="form-group">
												<div class="form-control-wrap">
													<div class="custom-control custom-checkbox">
														<input
															type="checkbox"
															class="custom-control-input"
															id="customCheck1zz"
															v-model="reportEntry.reportResultId"
														/>
														<label
															class="custom-control-label"
															for="customCheck1zz"
															>{{ $t('modal_inspection_show_result_id') }}</label
														>
													</div>
												</div>
											</div>
											<div class="form-group">
												<div class="form-control-wrap">
													<div class="custom-control custom-checkbox">
														<input
															type="checkbox"
															class="custom-control-input"
															id="customCheck10"
															v-model="reportEntry.reportResponsibility"
														/>
														<label
															class="custom-control-label"
															for="customCheck10"
															>{{ $t('modal_inspection_show_responsibility') }}</label
														>
													</div>
												</div>
											</div>
											<div class="form-group">
												<div class="form-control-wrap">
													<div class="custom-control custom-checkbox">
														<input
															type="checkbox"
															class="custom-control-input"
															id="customCheck15"
															v-model="reportEntry.reportDisableImageLink"
														/>
														<label
															class="custom-control-label"
															for="customCheck15"
															>{{ $t('modal_inspection_deactivate_links') }}</label
														>
													</div>
												</div>
											</div>
											<div class="form-group">
												<div class="form-control-wrap">
													<div class="custom-control custom-checkbox">
														<input
															type="checkbox"
															class="custom-control-input"
															id="customCheck17"
															v-model="reportEntry.stackOfParagraphs"
														/>
														<label
															class="custom-control-label"
															for="customCheck17"
															>{{ $t('modal_inspection_stack_paragraphs') }}<br /><span class="subinfo"
																>{{ $t('modal_inspection_stack_paragraphs_info') }}</span
															></label
														>
													</div>
												</div>
											</div>
											<div class="form-group">
												<div class="form-control-wrap">
													<div class="custom-control custom-checkbox">
														<input
															type="checkbox"
															class="custom-control-input"
															id="customCheck18"
															v-model="reportEntry.outputAllChapters"
														/>
														<label
															class="custom-control-label"
															for="customCheck18"
															>{{ $t('modal_inspection_output_all') }}</label
														>
													</div>
												</div>
											</div>
											<div class="form-group">
												<div class="form-control-wrap">
													<div class="custom-control custom-checkbox">
														<input
															type="checkbox"
															class="custom-control-input"
															id="customCheckBindHeading"
															v-model="reportEntry.bindHeadingToFirstRemark"
														/>
														<label
															class="custom-control-label"
															for="customCheckBindHeading"
															>{{ $t('modal_inspection_bind_heading') }}</label
														>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>

							<div
								class="tab-pane active"
								id="tabItemP2"
								style="padding-top: 20px"
							>
								<div
									class="form-group"
									style="border-bottom: 1px solid #e5e9f2; padding-bottom: 20px; margin-bottom: 20px;"
								>
									<div class="custom-control custom-switch">
										<input
											type="checkbox"
											class="custom-control-input"
											id="useGlobalSettings"
											v-model="reportEntry.useGlobalSettings"
											@change="onUseGlobalChange"
										/>
										<label class="custom-control-label" for="useGlobalSettings">
											<strong>{{ $t('modal_chapter_use_global') }}</strong>
										</label>
									</div>
									<small class="form-text text-muted">
										{{ $t('modal_inspection_global_desc') }}
									</small>
								</div>

								<div
									v-if="reportEntry.useGlobalSettings && globalSettings"
									class="alert alert-info"
									style="margin-bottom: 20px"
								>
									<strong>{{ $t('modal_inspection_currently_global') }}</strong><br />
									{{ $t('modal_inspection_currently_global_desc') }}
								</div>

								<table class="table table-sm">
									<thead>
										<tr>
											<th scope="col">{{ $t('modal_inspection_col_chapter') }}</th>
											<th scope="col">{{ $t('modal_inspection_col_title') }}</th>
											<th scope="col" style="text-align: center">{{ $t('modal_inspection_col_new_page') }}</th>
											<th scope="col" style="text-align: center">{{ $t('modal_inspection_col_hide') }}</th>
										</tr>
									</thead>
									<tbody>
										<tr v-for="item in main_chapters" :key="item.id">
											<td>
												<strong>{{ item.chapter }}</strong>
											</td>
											<td>{{ item.title }}</td>
											<td style="text-align: center">
												<div v-if="item.chapter != 'A'">
													<input
														type="checkbox"
														:id="'newpage-' + item.id"
														:value="item.chapter"
														v-model="reportEntry.checkedNewPage"
														:disabled="
															reportEntry.useGlobalSettings &&
																isMainChapter(item)
														"
													/>
												</div>
											</td>
											<td style="text-align: center">
												<div v-if="item.chapter && item.chapter.length === 1">
													<input
														type="checkbox"
														:id="'hide-' + item.id"
														:value="item.chapter"
														v-model="reportEntry.checkedHide"
														:disabled="
															reportEntry.useGlobalSettings &&
																isMainChapter(item)
														"
													/>
												</div>
											</td>
										</tr>
									</tbody>
								</table>
							</div>

							<div class="tab-pane" id="tabItemP3" style="padding-top: 20px">
								<div class="row gy-4">
									<div class="col-sm-4">
										<div class="form-group">
											<div class="form-control-wrap">
												<div class="form-group">
													<label class="form-label" for="default-01">H1</label>
													<div class="form-control-wrap">
														<input
															v-model="reportEntry.fontSizeH1"
															type="text"
															style="max-width: 30%"
															class="form-control"
															id="default-01"
															placeholder="fontSizeH1"
														/>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div class="col-sm-4">
										<div class="form-group">
											<div class="form-control-wrap">
												<div class="form-group">
													<label class="form-label" for="default-01">H2</label>
													<div class="form-control-wrap">
														<input
															v-model="reportEntry.fontSizeH2"
															type="text"
															style="max-width: 30%"
															class="form-control"
															id="default-01"
															placeholder="fontSizeH2"
														/>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div class="col-sm-4">
										<div class="form-group">
											<div class="form-control-wrap">
												<div class="form-group">
													<label class="form-label" for="default-01"
														>{{ $t('modal_inspection_h2_layout2') }}</label
													>
													<div class="form-control-wrap">
														<input
															v-model="reportEntry.fontSizeH2_2"
															type="text"
															style="max-width: 30%"
															class="form-control"
															id="default-01"
															placeholder="fontSizeH2_2"
														/>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>

								<div class="row gy-4">
									<div class="col-sm-4">
										<div class="form-group">
											<div class="form-control-wrap">
												<div class="form-group">
													<label class="form-label" for="default-01">H3</label>
													<div class="form-control-wrap">
														<input
															v-model="reportEntry.fontSizeH3"
															type="text"
															style="max-width: 30%"
															class="form-control"
															id="default-01"
															placeholder="fontSizeH3"
														/>
													</div>
												</div>
											</div>
										</div>
									</div>

									<div class="col-sm-4">
										<div class="form-group">
											<div class="form-control-wrap">
												<div class="form-group">
													<label class="form-label" for="default-01"
														>{{ $t('modal_inspection_toc1') }}</label
													>
													<div class="form-control-wrap">
														<input
															v-model="reportEntry.fontSizeToc1"
															type="text"
															style="max-width: 30%"
															class="form-control"
															id="default-01"
															placeholder="fontSizeToc1"
														/>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div class="col-sm-4">
										<div class="form-group">
											<div class="form-control-wrap">
												<div class="form-group">
													<label class="form-label" for="default-01"
														>{{ $t('modal_inspection_toc2') }}</label
													>
													<div class="form-control-wrap">
														<input
															v-model="reportEntry.fontSizeToc2"
															type="text"
															style="max-width: 30%"
															class="form-control"
															id="default-01"
															placeholder="fontSizeToc2"
														/>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div class="row gy-4">
									<div class="col-sm-4">
										<div class="form-group">
											<div class="form-control-wrap">
												<div class="form-group">
													<label class="form-label" for="default-01"
														>{{ $t('modal_inspection_cover_sheet') }}</label
													>
													<div class="form-control-wrap">
														<input
															v-model="reportEntry.fontSizeText"
															type="text"
															style="max-width: 30%"
															class="form-control"
															id="default-01"
															placeholder="fontSizeText"
														/>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div class="col-sm-4">
										<div class="form-group">
											<div class="form-control-wrap">
												<div class="form-group">
													<label class="form-label" for="default-01"
														>{{ $t('modal_inspection_table_results') }}</label
													>
													<div class="form-control-wrap">
														<input
															v-model="reportEntry.fontSizeTable"
															type="text"
															style="max-width: 30%"
															class="form-control"
															id="default-01"
															placeholder="fontSizeTable"
														/>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div class="col-sm-4">
										<div class="form-group">
											<div class="form-control-wrap">
												<div class="form-group">
													<label class="form-label" for="default-01"
														>{{ $t('modal_inspection_text') }}</label
													>
													<div class="form-control-wrap">
														<input
															v-model="reportEntry.fontSizeCopy"
															type="text"
															style="max-width: 30%"
															class="form-control"
															id="default-01"
															placeholder="fontSizeCopy"
														/>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>

								<div class="row gy-4">
									<div class="col-sm-4">
										<div class="form-group">
											<div class="form-control-wrap">
												<div class="form-group">
													<label class="form-label" for="default-01"
														>{{ $t('modal_inspection_footer') }}</label
													>
													<div class="form-control-wrap">
														<input
															v-model="reportEntry.fontSizeFooter"
															type="text"
															style="max-width: 30%"
															class="form-control"
															id="default-01"
															placeholder="fontSizeFooter"
														/>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div class="col-sm-4">
										<div class="form-group">
											<div class="form-control-wrap">
												<div class="form-group">
													<label class="form-label" for="default-01"
														>{{ $t('modal_inspection_conclusion') }}</label
													>
													<div class="form-control-wrap">
														<input
															v-model="reportEntry.fontSizeConclusion"
															type="text"
															style="max-width: 30%"
															class="form-control"
															id="default-01"
															placeholder="fontSizeConclusion"
														/>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div class="col-sm-4">
										<div class="form-group">
											<div class="form-control-wrap">
												<div class="form-group">
													<label class="form-label" for="default-01"
														>{{ $t('modal_inspection_disclaimer') }}</label
													>
													<div class="form-control-wrap">
														<input
															v-model="reportEntry.fontSizeDisclaimer"
															type="text"
															style="max-width: 30%"
															class="form-control"
															id="default-01"
															placeholder="fontSizeDisclaimer"
														/>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>

								<div class="row gy-4">
									<div class="col-sm-4">
										<div class="form-group">
											<div class="form-control-wrap">
												<div class="form-group">
													<label class="form-label" for="default-01"
														>{{ $t('modal_inspection_color_h1') }}</label
													>
													<div class="form-control-wrap">
														<input
															v-model="reportEntry.headlineColor1"
															type="text"
															style="max-width: 30%"
															class="form-control"
															id="default-01"
															placeholder="headlineColor1"
														/>
														<input
															type="color"
															class="form-control"
															style="cursor:pointer;height:30px;padding: 0px; border:none;max-width: 30%"
															v-model="reportEntry.headlineColor1"
														/>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div class="col-sm-4">
										<div class="form-group">
											<div class="form-control-wrap">
												<div class="form-group">
													<label class="form-label" for="default-01"
														>{{ $t('modal_inspection_color_h2') }}</label
													>
													<div
														class="form-control-wrap"
														style="position: relative;"
													>
														<input
															v-model="reportEntry.headlineColor2"
															type="text"
															style="max-width: 30%"
															class="form-control"
															id="default-01"
															placeholder="headlineColor2"
														/>
														<input
															type="color"
															class="form-control"
															style="cursor:pointer;height:30px;padding: 0px; border:none;max-width: 30%"
															v-model="reportEntry.headlineColor2"
														/>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div class="col-sm-4">
										<div class="form-group"></div>
									</div>
								</div>
							</div>

							<div class="tab-pane" id="tabItemP4" style="padding-top: 20px">
								<table class="table">
									<thead>
										<tr>
											<th scope="col"></th>
											<th scope="col"></th>
										</tr>
									</thead>
									<tbody>
										<tr>
											<td>
												{{ $t('modal_inspection_col_width') }}
											</td>
											<td>
												<input
													type="text"
													maxlength="3"
													style="width: 200px"
													class="form-control"
													v-model="reportEntry.stateColWidth"
												/>
											</td>
										</tr>
										<tr>
											<td>
												<div class="icon-bg">
													<font-awesome-icon
														style="font-size:20px;color:#3EC997"
														icon="fa-solid fa-check"
													/>
												</div>
											</td>
											<td>
												<input
													type="text"
													style="width: 200px"
													class="form-control"
													v-model="reportEntry.stateV"
												/>
											</td>
										</tr>
										<tr>
											<td>
												<div class="icon-bg">
													<font-awesome-icon
														style="font-size:20px;color:#009dff"
														icon="fa-solid fa-circle-info"
													/>
												</div>
											</td>
											<td>
												<input
													type="text"
													style="width: 200px"
													class="form-control"
													v-model="reportEntry.stateI"
												/>
											</td>
										</tr>
										<tr>
											<td>
												<div class="icon-bg">
													<font-awesome-icon
														style="font-size:20px;color:#0000ff"
														icon="fa-solid fa-triangle-exclamation"
													/>
												</div>
											</td>
											<td>
												<input
													type="text"
													style="width: 200px"
													class="form-control"
													v-model="reportEntry.stateE"
												/>
											</td>
										</tr>
										<tr>
											<td>
												<div class="icon-bg">
													<font-awesome-icon
														style="font-size:20px;color:#ffff00"
														icon="fa-solid fa-triangle-exclamation"
													/>
												</div>
											</td>
											<td>
												<input
													type="text"
													style="width: 200px"
													class="form-control"
													v-model="reportEntry.stateP"
												/>
											</td>
										</tr>
										<tr>
											<td>
												<div class="icon-bg">
													<font-awesome-icon
														style="font-size:20px;color:#ff8000"
														icon="fa-solid fa-triangle-exclamation"
													/>
												</div>
											</td>
											<td>
												<input
													type="text"
													style="width: 200px"
													class="form-control"
													v-model="reportEntry.statePP"
												/>
											</td>
										</tr>
										<tr>
											<td>
												<div class="icon-bg">
													<font-awesome-icon
														style="font-size:20px;color:#ff0000"
														icon="fa-solid fa-triangle-exclamation"
													/>
												</div>
											</td>
											<td>
												<input
													type="text"
													style="width: 200px"
													class="form-control"
													v-model="reportEntry.statePPP"
												/>
											</td>
										</tr>
										<tr>
											<td>
												<div class="icon-bg">
													X
												</div>
											</td>
											<td>
												<input
													type="text"
													style="width: 200px"
													class="form-control"
													v-model="reportEntry.stateNT"
												/>
											</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
						<div class="form-group" style="margin-top: 30px">
							<button
								type="button"
								style="text-align: center; width: 100%"
								class="btn-lg btn-primary"
								@click="updateSettings"
							>
								{{ $t('common_save') }}
							</button>
						</div>
					</form>
				</div>
				<div class="modal-footer bg-light"></div>
			</div>
		</div>
	</div>
</template>

<script>
import { EventBus } from '@/event-bus.js';

import {
	getReportSettings,
	saveReportSettings,
} from '@/services/reporting.service';

import { getGlobalChapterSettings } from '@/services/reporting-v3.service';

export default {
	props: ['chapterId', 'projectNumber', 'inspectionEntry'],
	data() {
		return {
			reportEntry: {},
			saved: false,
			selectedColor: '#ff0000', // Standardfarbe
			globalSettings: {},
			originalCheckedNewPage: [],
			originalCheckedHide: [],
		};
	},

	watch: {
		'reportEntry.checkedHide': {
			handler(newValue) {
				if (newValue && Array.isArray(newValue)) {
					// Update checkedHideFull with both id and chapter
					this.reportEntry.checkedHideFull = newValue.map((chapter) => {
						const item = this.main_chapters.find((c) => c.chapter === chapter);
						return {
							id: item ? item.id : null,
							chapter: chapter,
						};
					});
				} else {
					this.reportEntry.checkedHideFull = [];
				}
			},
			deep: true,
		},
		'reportEntry.checkedNewPage': {
			handler(newValue) {
				if (newValue && Array.isArray(newValue)) {
					// Update checkedNewPageFull with both id and chapter
					this.reportEntry.checkedNewPageFull = newValue.map((chapter) => {
						const item = this.main_chapters.find((c) => c.chapter === chapter);
						return {
							id: item ? item.id : null,
							chapter: chapter,
						};
					});
				} else {
					this.reportEntry.checkedNewPageFull = [];
				}
			},
			deep: true,
		},
	},

	computed: {
		imglib_list: function() {
			return this.$store.state.rp_imglib_project;
		},
		main_chapters: function() {
			return this.$store.state.main_chapters;
		},
	},
	beforeDestroy() {
		EventBus.$off('keydown');
	},
	mounted() {
		EventBus.$off('keydown');
		EventBus.$on('keydown', this.keyDown);

		$('#modalDefault').modal('show');

		const ref = this;

		$('#modalDefault').on('hidden.bs.modal', function() {
			ref.$emit('dialogClosed', { saved: ref.saved, cat: 'inspection' });
		});

		this.reportEntry = {
			reportimage: false,
			reportimagefile: '',
			checkedNewPage: [],
			checkedNewPageFull: [],
			checkedHide: [],
			checkedHideFull: [],
			useGlobalSettings: false,
		};

		// Load global chapter settings first
		getGlobalChapterSettings()
			.then((response) => {
				if (response && response.data && response.data.settings) {
					// Store global settings by chapter ID
					response.data.settings.forEach((setting) => {
						if (setting.chapterId && setting.settings) {
							this.globalSettings[setting.chapterId] = setting.settings;
						}
					});
				}

				// After global settings are loaded, load report settings
				return getReportSettings(
					this.projectNumber,
					this.inspectionEntry.uid,
					this.$store.state.rp_project.uid
				);
			})
			.then((d) => {
				if (d) {
					if (d.data.report) {
						this.reportEntry = d.data.report;

						// Handle checkedHide/checkedHideFull
						if (
							this.reportEntry.checkedHideFull &&
							Array.isArray(this.reportEntry.checkedHideFull) &&
							this.reportEntry.checkedHideFull.length > 0
						) {
							// If checkedHideFull exists, derive checkedHide from it
							this.reportEntry.checkedHide = this.reportEntry.checkedHideFull.map(
								(item) => item.chapter
							);
						} else if (
							this.reportEntry.checkedHide &&
							Array.isArray(this.reportEntry.checkedHide)
						) {
							// If only checkedHide exists, create checkedHideFull from it
							this.reportEntry.checkedHideFull = this.reportEntry.checkedHide.map(
								(chapter) => {
									const item = this.main_chapters.find(
										(c) => c.chapter === chapter
									);
									return {
										id: item ? item.id : null,
										chapter: chapter,
									};
								}
							);
						} else {
							this.reportEntry.checkedHide = [];
							this.reportEntry.checkedHideFull = [];
						}

						// Handle checkedNewPage/checkedNewPageFull
						if (
							this.reportEntry.checkedNewPageFull &&
							Array.isArray(this.reportEntry.checkedNewPageFull) &&
							this.reportEntry.checkedNewPageFull.length > 0
						) {
							// If checkedNewPageFull exists, derive checkedNewPage from it
							this.reportEntry.checkedNewPage = this.reportEntry.checkedNewPageFull.map(
								(item) => item.chapter
							);
						} else if (
							this.reportEntry.checkedNewPage &&
							Array.isArray(this.reportEntry.checkedNewPage)
						) {
							// If only checkedNewPage exists, create checkedNewPageFull from it
							this.reportEntry.checkedNewPageFull = this.reportEntry.checkedNewPage.map(
								(chapter) => {
									const item = this.main_chapters.find(
										(c) => c.chapter === chapter
									);
									return {
										id: item ? item.id : null,
										chapter: chapter,
									};
								}
							);
						} else {
							this.reportEntry.checkedNewPage = [];
							this.reportEntry.checkedNewPageFull = [];
						}

						// Set default for useGlobalSettings if not present
						if (this.reportEntry.useGlobalSettings === undefined) {
							this.reportEntry.useGlobalSettings = false;
						}

						// Store original individual settings
						this.originalCheckedNewPage = [
							...(this.reportEntry.checkedNewPage || []),
						];
						this.originalCheckedHide = [
							...(this.reportEntry.checkedHide || []),
						];

						// If useGlobalSettings is true, apply global settings now
						if (this.reportEntry.useGlobalSettings === true) {
							this.applyGlobalSettings();
						}
					}

					this.$store.state.rp_imglib_project = d.data.imglib;
				}
			})
			.catch((error) => {
				console.error('Error loading global chapter settings:', error);
			});

		// ------
	},
	methods: {
		keyDown: function(cat) {
			if (cat == 'save') {
				this.updateSettings();
			}
		},

		updateSettings: async function() {
			// Save report settings (including useGlobalSettings flag)
			await saveReportSettings(
				this.projectNumber,
				this.inspectionEntry.uid,
				this.reportEntry
			).then(() => {
				this.saved = true;
				$('#modalDefault').modal('hide');
			});
		},

		isMainChapter: function(item) {
			const mainChapterIds = [
				'inspectionDetails',
				'general',
				'machinedata',
				'components',
				'findings',
				'conclusion',
				'disclaimer',
				'generalB1',
				'generalB2',
				'generalB3',
				'generalB4',
				'generalB5',
			];

			// Check if this item's id (cleaned of trailing numbers) is in the main chapters list
			if (!item || !item.id) return false;

			const cleanId = item.id.replace(/\d+$/, '');
			return (
				mainChapterIds.includes(cleanId) || mainChapterIds.includes(item.id)
			);
		},

		onUseGlobalChange: function() {
			if (this.reportEntry.useGlobalSettings) {
				// Save current individual settings before applying global
				this.originalCheckedNewPage = [
					...(this.reportEntry.checkedNewPage || []),
				];
				this.originalCheckedHide = [...(this.reportEntry.checkedHide || [])];
				// Apply global settings
				this.applyGlobalSettings();
			} else {
				// Restore original individual settings
				this.reportEntry.checkedNewPage = [...this.originalCheckedNewPage];
				this.reportEntry.checkedHide = [...this.originalCheckedHide];
				this.$forceUpdate();
			}
		},

		applyGlobalSettings: function() {
			// Keep only sub-chapters (not main chapters) from current settings
			const subChapterNewPage = this.reportEntry.checkedNewPage.filter(
				(chapter) => {
					const item = this.main_chapters.find((c) => c.chapter === chapter);
					return !item || !this.isMainChapter(item);
				}
			);

			const subChapterHide = this.reportEntry.checkedHide.filter((chapter) => {
				const item = this.main_chapters.find((c) => c.chapter === chapter);
				return !item || !this.isMainChapter(item);
			});

			// Start with sub-chapters only
			const newCheckedNewPage = [...subChapterNewPage];
			const newCheckedHide = [...subChapterHide];

			// Apply global settings by iterating through each global setting
			Object.keys(this.globalSettings).forEach((chapterId) => {
				const globalSetting = this.globalSettings[chapterId];

				// Find the main chapter entry with this chapterId
				const mainChapterEntry = this.main_chapters.find((c) => {
					if (c.id === chapterId) return true;

					// Also try matching base ID
					let cleanId = c.id;
					cleanId = cleanId.replace(/[A-Z][\d.]+$/, '');
					cleanId = cleanId.replace(/\d+$/, '');

					return cleanId === chapterId;
				});

				if (mainChapterEntry && this.isMainChapter(mainChapterEntry)) {
					const chapterLetter = mainChapterEntry.chapter;

					// Apply newpage setting: add to checkedNewPage if true
					if (globalSetting.newpage && chapterLetter !== 'A') {
						if (!newCheckedNewPage.includes(chapterLetter)) {
							newCheckedNewPage.push(chapterLetter);
						}
					}

					// Apply hideProgressBar setting: add to checkedHide if true
					// Allow both single-letter chapters (A, B, C) and sub-chapters (B.1, B.2, etc.)
					if (globalSetting.hideProgressBar && chapterLetter) {
						if (!newCheckedHide.includes(chapterLetter)) {
							newCheckedHide.push(chapterLetter);
						}
					}
				}
			});

			// Update the reportEntry
			this.reportEntry.checkedNewPage = newCheckedNewPage;
			this.reportEntry.checkedHide = newCheckedHide;

			// Force update of the UI
			this.$forceUpdate();
		},
	},
};
</script>

<style>
.icon-bg {
	padding: 10px 0 5px 0;
	text-align: center;
	background-color: #e5ecf5;
}

.subinfo {
	color: #8094ae;
}
</style>
